function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStreamActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-stream-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.43,16.38a.9.9,0,0,1-.85-.62l-4-12L5,8.47a.9.9,0,0,1-.85.62H.9a.9.9,0,1,1,0-1.8H3.49L5.72.62a.9.9,0,0,1,1.71,0l4,12L13,7.91a.9.9,0,0,1,.85-.62H17.1a.9.9,0,0,1,0,1.8H14.51l-2.23,6.67A.9.9,0,0,1,11.43,16.38Z",
    style: {
      fill: "#3fa9f5"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStreamActive);
export default __webpack_public_path__ + "static/media/icon-stream-active.d6529087c76590898bf4465d7e013d6b.svg";
export { ForwardRef as ReactComponent };